export enum OtpVerificationType {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  DEVICE = 'DEVICE',
}
